<template lang="pug">
.home-video(:class="classMod ? `home-video_${classMod}`: false")
  .home-video__cont.cont
    .home-video__video(v-for="(video, i) in videos", :key="i")
      iframe.home-video__frame(
        :src="video.src",
        frameborder='0',
        allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture',
        loading='lazy'
      )
</template>

<script>
import '@/assets/styles/components/home-video.sass'

export default {
  name: 'HomeVideo',
  props: {
    classMod: String
  },
  data () {
    return {
      videos: [
        { src: 'https://vk.com/video_ext.php?oid=-10792477&id=456239399&hd=3' }
      ]
    }
  }
}
</script>
